import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import  './Modal.css'
const ModalComponent  = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* <Button variant="primary" onClick={handleShow}> */}
        {/* Launch demo modal */}
        <FontAwesomeIcon  icon={faSearch}  onClick={handleShow} className='top-icons top-glass' />
      {/* </Button> */}

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Search</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className='top-form'>
            {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="name@example.com"
                autoFocus
              />
            </Form.Group> */}


            <Form.Control
            type="search"
            placeholder="Search"
            className="me-2 mt-2 mb-2 form-control top-search"
            aria-label="Search"
           
          />
          <Button variant="outline-primary">Search</Button>
        </Form>



          
          {/* </Form> */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
           Register
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalComponent